import React, { useEffect, useState } from 'react';
import currency from 'currency.js';
import cn from 'classnames';
import Item from './Item';
import ItemBuilder from './ItemBuilder';
import styles from './HolidayBuilder.module.scss';
import banner from './assets/holiday-banner.png';
import Button from '../../../Button/v2';
import { useEmailInterceptor } from '../../../EmailInterceptor/EmailInterceptor';
import { usePrevious } from '../../../PackageBuilders/MultiPose/hooks';

export function ItemSubtitle({ price }) {
  return <div>{currency(price).format()}</div>;
}

export default function ItemAdder({ mutation, addons, backgrounds, options, poses = [], siblingImages = [], onSelectBackground }) {
  const [selectedAddonType, setSelectedAddonType] = useState('');
  const [addonSheetsPerType, setAddonSheetsPerType] = useState({});
  const [pose, setPose] = useState(null);
  const [background, setBackground] = useState(null);
  const { intercept } = useEmailInterceptor();

  const previousAddonType = usePrevious(selectedAddonType);

  // Filter addons before rendering
  const filteredAddons = addons.filter((addon) => {
    if (addon.cssName === 'sibling') return false;
    
    if (addon._attributes.cssName.includes('grad')) {
      return poses[2]?._attributes?.url?.includes('-S0');
    }
    
    return true;
  });

  const handleConfirmation = (addonSheets) => intercept(() => {
    setAddonSheetsPerType((prev) => ({ ...prev, [selectedAddonType]: addonSheets }));
    // setSelectedAddonType('');
    mutation.mutate({ addonSheets });
  });

  useEffect(() => {
    if (selectedAddonType === previousAddonType) return;

    setPose(null);
    setBackground(null);
  }, [selectedAddonType]);

  useEffect(() => {
    if (selectedAddonType === '') return;

    const selectablePoses = selectedAddonType === 'sibling' ? siblingImages : (poses.length > 0 ? poses : siblingImages);
    // const selectableBackgrounds = backgrounds.filter((bg) => bg.productTypeNames.includes(selectedAddonType));
    const selectableBackgrounds = backgrounds;

    setPose(selectablePoses[Math.floor(Math.random() * selectablePoses.length)]);
    setBackground(selectableBackgrounds[Math.floor(Math.random() * selectableBackgrounds.length)]);
    const interval = setInterval(() => {
      const rand = Math.round(Math.random());
      const changePose = rand === 0;

      if (changePose) {
        setPose(selectablePoses[Math.floor(Math.random() * selectablePoses.length)]);
      } else {
        setBackground(selectableBackgrounds[Math.floor(Math.random() * selectableBackgrounds.length)]);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [selectedAddonType]);

  if (selectedAddonType !== '') {
    if (!pose) return null;
    if (!background) return null;

    const isSiblingPose = pose.id === siblingImages[0]?.id;

    return (
      <ItemBuilder
        isLoading={mutation.isLoading}
        isSiblingPose={isSiblingPose}
        selectedAddonType={selectedAddonType}
        addons={addons.filter((addon) => addon.cssName === selectedAddonType)}
        initialItems={addonSheetsPerType[selectedAddonType] || []}
        background={background}
        backgrounds={backgrounds}
        isWithoutPackage={false}
        pose={pose}
        onConfirm={handleConfirmation}
        onCancelProps={{ onClick: () => setSelectedAddonType(''), text: 'Back' }}
      />
    );
  }

  /*useEffect(() => {
    addons.forEach(addon => {
      console.log(addon);
      console.log('Addon imageUrl:', addon._attributes.cssName);
    });
  }, [addons]);

  useEffect(() => {
    poses.forEach(pose => {
      console.log(pose);
      console.log('Pose imageUrl:', pose._attributes.url);
    });
  }, [poses]);*/

  const handleSelectBackground = () => intercept(() => {
    onSelectBackground(Object.values(addonSheetsPerType).flat());
  });

  return (
    <div className={cn(styles.page, { [styles.morePadding]: false }, selectedAddonType)}>
      <div className={styles.itemsWrapper}>
      {addons.filter((addon) => {
          // First check if it's not a sibling addon
          if (addon.cssName === 'sibling') return false;
          
          // If cssName includes 'grad', check if pose url includes '-s0'
          if (addon._attributes.cssName.includes('grad')) {
            return poses[0]?._attributes?.url?.includes('-S0');
          }
          
          // Return true for all other addons
          return true;
        }).map((addon) => (
          <Item
            addon={addon}
            key={addon.name}
            titleText={addon.name}
            subtitleText={<ItemSubtitle price={addon.priceWithout} />}
            variant={addon.cssName}
            onClick={() => setSelectedAddonType(addon.cssName)}
            background={backgrounds[0]}
            pose={poses[0]}
          />
        ))}
      </div>
      {false && (
        <div className={styles.btnWrapper}>
          <Button onClick={handleSelectBackground}>Select Backgrounds</Button>
        </div>
      )}
    </div>
  );
}
